'use strict';

/**
 * Modified the given url with the pagination parameters
 * @param {Object} url - url
 * @return {string} url with pagination parameters
 */
function getUrlWithPagination(url) {
	let urlWithPagination = new URL(url, window.location);
	let currentBrowserPath = new URL(window.location.href);

	if (currentBrowserPath.searchParams.get('start')) {
		urlWithPagination.searchParams.append('start', currentBrowserPath.searchParams.get('start'));
	}

	if (currentBrowserPath.searchParams.get('sz')) {
		urlWithPagination.searchParams.append('sz', currentBrowserPath.searchParams.get('sz'));
	}

	return urlWithPagination;
}

/**
 * Builds a url for showMoreButton with all the pagination values
 * @param {Object} showMoreUrlWithPagination - showMoreUrl with all the pagination values
 * @param {Object} currentBrowserUrl - the current browser url without the pagination params
 * @returns {string} showMoreUrl with all the necessary pagination parameters
 */
function buildShowMoreUrl(showMoreUrlWithPagination, currentBrowserUrl) {
	let showMoreUrlWithParams = currentBrowserUrl;
	let defaultPageSize = parseInt($('input[name="defaultPageSize"]').val(), 10);
	let pageSize;

	showMoreUrlWithPagination.searchParams.forEach(function (value, key) {
		if (key === 'cgid') return;

		if (!currentBrowserUrl.searchParams.get(key)) {
			switch (key) {
				case 'start':
					showMoreUrlWithParams.searchParams.append(key, 0);
					break;
				case 'sz':
					pageSize = parseInt(showMoreUrlWithPagination.searchParams.get('start'), 10)
						+ parseInt(value, 10);
					showMoreUrlWithParams.searchParams.append(key, pageSize);
					break;
				default:
					showMoreUrlWithParams.searchParams.append(key, value);
					break;
			}
		} else {
			if (key === 'sz') {
				pageSize = parseInt(showMoreUrlWithPagination.searchParams.get('start'), 10)
					+ defaultPageSize;
				showMoreUrlWithParams.searchParams.set(key, pageSize);
				return;
			}

			showMoreUrlWithParams.searchParams.set(key, value);
		}
	});

	return showMoreUrlWithParams;
}

/**
 * Builds a url for applyFilter or sorting with all the pagination values
 * @param {Object} urlWithPagination - url with all the pagination values
 * @param {Object} cleanBrowserURL - the browser url without the pagination params
 * @returns {string} clean url with all the necessary pagination parameters
 */
function buildApplyFilterOrSortUrl(urlWithPagination, cleanBrowserURL) {
	let urlWithParams = cleanBrowserURL;

	urlWithPagination.searchParams.forEach(function (value, key) {
		if (key === 'cgid') return;

		if (!cleanBrowserURL.searchParams.get(key)) {
			urlWithParams.searchParams.append(key, value);
		} else {
			urlWithParams.searchParams.set(key, value);
		}
	});

	return urlWithParams;
}

/**
 * Add the pagination queries to the browser history
 * @param {Object} urlWithPagination - url with pagination parameters
 * @param {string} action - the action triggered
 */
function addQueryToBrowserHistory(urlWithPagination, action) {
	let currentSrule = urlWithPagination.searchParams.get('srule');
	let cleanBaseUrl = $('input[name="baseUrl"]').val();
	let cleanBrowserURL = new URL(cleanBaseUrl);
	let browserUrlWithParams;
	let currentBrowserUrl;

	switch (action) {
		case 'showMore':
			currentBrowserUrl = new URL(window.location.href);
			browserUrlWithParams = buildShowMoreUrl(urlWithPagination, currentBrowserUrl);
			break;
		case 'applyFilter':
		case 'sort':
			browserUrlWithParams = buildApplyFilterOrSortUrl(urlWithPagination, cleanBrowserURL);
			break;
		default:
			browserUrlWithParams = cleanBrowserURL;
			break;
	}

	if (currentSrule && !browserUrlWithParams.searchParams.get('srule')) {
		browserUrlWithParams.searchParams.append('srule', currentSrule);
	}

	window.history.pushState({}, null, browserUrlWithParams.toString());
}

module.exports = {
	getUrlWithPagination: getUrlWithPagination,
	addQueryToBrowserHistory: addQueryToBrowserHistory
};
